import _ from 'lodash';

import { usePermissionContext, useWorkspaceContext } from '../context';

export enum AtsCustomAPIAccess {
  JOB_FIELDS_CUSTOMISATION = 'JOB_FIELDS_CUSTOMISATION',
  MAPPING_FIELDS_CUSTOMISATION = 'MAPPING_FIELDS_CUSTOMISATION',
  SUBMISSION_FIELDS_CUSTOMISATION = 'SUBMISSION_FIELDS_CUSTOMISATION',
  JOB_ATTRIBUTE_VISIBILITY_SETTINGS = 'JOB_ATTRIBUTE_VISIBILITY_SETTINGS',
  STAGE_STATUS_CHANGES = 'STAGE_STATUS_CHANGES',
  DATA_DOWNLOAD_SETTINGS_IN_JOBS = 'DATA_DOWNLOAD_SETTINGS_IN_JOBS',
  DATA_DOWNLOAD_SETTINGS_IN_CANDIDATES = 'DATA_DOWNLOAD_SETTINGS_IN_CANDIDATES',
  RECRUITER_ACTIONS = 'RECRUITER_ACTIONS',
  CANDIDATE_RESPONSES = 'CANDIDATE_RESPONSES',
  PRISM_SETTINGS = 'PRISM_SETTINGS',
  PROMPT_FOR_CHATGPT = 'PROMPT_FOR_CHATGPT',
  DATA_SHARING_SETTINGS = 'DATA_SHARING_SETTINGS',
  PAGINATION_SETTINGS = 'PAGINATION_SETTINGS',
  CALL_SETTINGS = 'CALL_SETTINGS',
  REASON_FOR_CLOSING_JOB_SETTING = 'REASON_FOR_CLOSING_JOB_SETTING',
  JOB_ADMIN_TEAM_AS_MANDATORY = 'JOB_ADMIN_TEAM_AS_MANDATORY',
  NOTIFICATION_SETTINGS = 'NOTIFICATION_SETTINGS',
  CAREER_PAGE_SETTINGS = 'CAREER_PAGE_SETTINGS',
  CLIENT_SETTINGS = 'CLIENT_SETTINGS',
  INVOICE_SETTINGS = 'INVOICE_SETTINGS',
  MANAGE_JOB_FIELDS_CUSTOMISATION = 'MANAGE_JOB_FIELDS_CUSTOMISATION',
  MANAGE_MAPPING_FIELDS_CUSTOMISATION = 'MANAGE_MAPPING_FIELDS_CUSTOMISATION',
  MANAGE_SUBMISSION_FIELDS_CUSTOMISATION = 'MANAGE_SUBMISSION_FIELDS_CUSTOMISATION',
  MANAGE_JOB_ATTRIBUTE_VISIBILITY_SETTINGS = 'MANAGE_JOB_ATTRIBUTE_VISIBILITY_SETTINGS',
  MANAGE_STAGE_STATUS_CHANGES = 'MANAGE_STAGE_STATUS_CHANGES',
  MANAGE_DATA_DOWNLOAD_SETTINGS_IN_JOBS = 'MANAGE_DATA_DOWNLOAD_SETTINGS_IN_JOBS',
  MANAGE_DATA_DOWNLOAD_SETTINGS_IN_CANDIDATES = 'MANAGE_DATA_DOWNLOAD_SETTINGS_IN_CANDIDATES',
  MANAGE_PRISM_SETTINGS = 'MANAGE_PRISM_SETTINGS',
  MANAGE_DATA_SHARING_SETTINGS = 'MANAGE_DATA_SHARING_SETTINGS',
  MANAGE_RECRUITER_ACTIONS = 'MANAGE_RECRUITER_ACTIONS',
  MANAGE_CANDIDATE_RESPONSES = 'MANAGE_CANDIDATE_RESPONSES',
  MANAGE_REASON_FOR_CLOSING_JOB_SETTING = 'MANAGE_REASON_FOR_CLOSING_JOB_SETTING',
  MANAGE_JOB_ADMIN_TEAM_AS_MANDATORY = 'MANAGE_JOB_ADMIN_TEAM_AS_MANDATORY',
  MANAGE_NOTIFICATION_SETTINGS = 'MANAGE_NOTIFICATION_SETTINGS',
  MANAGE_PAGINATION_SETTINGS = 'MANAGE_PAGINATION_SETTINGS',
  MANAGE_CALL_SETTINGS = 'MANAGE_CALL_SETTINGS',
  MANAGE_CAREER_PAGE_SETTINGS = 'MANAGE_CAREER_PAGE_SETTINGS',
  MANAGE_CLIENT_SETTINGS = 'MANAGE_CLIENT_SETTINGS',
  MANAGE_INVOICE_SETTINGS = 'MANAGE_INVOICE_SETTINGS',
}

export const useAtsCustomAPIAccess = (actions: AtsCustomAPIAccess[]) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();
  const data = actions.map(
    (action) =>
      !_.isEmpty(workspace.role) &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('ATS_CUSTOM', action, [workspace.role ?? ''])
  );
  return { access: data, owns: workspace.owns };
};
